<template>
  <div>
    <FormWizardStepHeader
      title="Contact preference"
      optional
      description="Let startups know how they can reach out to you"
    />

    <FormItem
      label="Select one or more preferences"
      invalid-message="Please select the preference"
      :state="
        $v.contactPreferences.$dirty ? !$v.contactPreferences.$error : null
      "
    >
      <b-form-checkbox-group
        v-model="form.contactPreferences"
        buttons
        class="btn-group-outline-spaced"
        @input="$v.contactPreferences.$touch()"
      >
        <b-form-checkbox
          v-for="item in contactPreferences"
          :key="item.value"
          :value="item.value"
          >{{ item.label }}</b-form-checkbox
        >
      </b-form-checkbox-group>
    </FormItem>

    <FormItem
      v-if="isPhone"
      label="Enter phone number"
      invalid-message="Please enter phone number"
      :state="$v.contactPhone.$dirty ? !$v.contactPhone.$error : null"
      required
    >
      <b-form-input
        v-model="form.contactPhone"
        :state="$v.contactPhone.$dirty ? !$v.contactPhone.$error : null"
        placeholder="Phone number"
        @blur="$v.contactPhone.$touch()"
      />
    </FormItem>

    <FormItem
      v-if="isEmail || isSignup"
      label="Enter email address"
      invalid-message="Please enter email address"
      :state="$v.contactEmail.$dirty ? !$v.contactEmail.$error : null"
      required
    >
      <b-form-input
        v-model="form.contactEmail"
        :state="$v.contactEmail.$dirty ? !$v.contactEmail.$error : null"
        placeholder="Email address"
        @blur="$v.contactEmail.$touch()"
      />
    </FormItem>

    <FormItem
      v-if="isWebsite"
      label="Enter website"
      invalid-message="Please enter website"
      :state="$v.contactWebsite.$dirty ? !$v.contactWebsite.$error : null"
      required
    >
      <b-form-input
        v-model="form.contactWebsite"
        :state="$v.contactWebsite.$dirty ? !$v.contactWebsite.$error : null"
        placeholder="https://"
        @blur="$v.contactWebsite.$touch()"
      />
    </FormItem>

    <FormItem
      v-if="isText"
      label="Free text"
      invalid-message="Feel free to write anything here"
      :state="$v.contactText.$dirty ? !$v.contactText.$error : null"
      required
    >
      <template slot="description">
        <FormInputLengthCounter
          label="Add a text between 0 and 500 characters"
          :min="0"
          :max="500"
          :text="form.contactText"
        />
      </template>

      <template>
        <b-form-textarea
          v-model="form.contactText"
          :rows="5"
          :max-rows="10"
          placeholder="Enter a text here"
          @blur="$v.contactText.$touch()"
        />
      </template>
    </FormItem>
  </div>
</template>

<script>
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import FormItem from '@/components/form/FormItem'
import FormInputLengthCounter from '@/components/form/FormInputLengthCounter'

export default {
  name: 'InvestorFormStepContact',
  components: {
    FormWizardStepHeader,
    FormInputLengthCounter,
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      }
    }
  },
  computed: {
    contactPreferences() {
      return this.$store.getters['meta/investorContactPreferences']
    },
    isEmail() {
      return (this.form.contactPreferences || []).indexOf('email') > -1
    },
    isText() {
      return (this.form.contactPreferences || []).indexOf('text') > -1
    },
    isPhone() {
      return (this.form.contactPreferences || []).indexOf('phone') > -1
    },
    isWebsite() {
      return (this.form.contactPreferences || []).indexOf('website') > -1
    },
    isSignup() {
      return (this.form.contactPreferences || []).indexOf('signup') > -1
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  }
}
</script>
